import { __awaiter, __decorate } from "tslib";
import ComponentRegistry from '@slickdeals/durango/dist/javascript/core/componentRegistry';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { stateable } from '@slickdeals/durango/dist/javascript/decorators/stateable';
import { ClassNames as CheckboxClassNames } from '@slickdeals/blueprint-twig/javascript/components/checkbox';
import { ClassNames as FormClassNames, name as FormName } from '@slickdeals/blueprint-twig/javascript/components/form';
import { ClassNames as InlineFormClassNames } from '@slickdeals/blueprint-twig/javascript/components/inlineForm';
import { ClassNames as TextAreaClassNames } from '@slickdeals/blueprint-twig/javascript/components/textArea';
import BlueprintComponent from '@slickdeals/blueprint-twig/javascript/core/blueprintComponent';
import './inlineReply';
import '../../scss/patterns/commentInlineReply.scss';
// The name of the module
export const name = 'CommentInlineReply';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-commentInlineReply";
    ClassNames["JavaScript"] = "js-commentInlineReply";
    ClassNames["CheckboxContainer"] = "js-commentInlineReply_checkboxContainer";
    ClassNames["Redirect"] = "js-commentInlineReply_redirect";
    ClassNames["RedirectVisible"] = "bp-p-commentInlineReply_redirect--visible";
})(ClassNames || (ClassNames = {}));
var UrlRegExDetection;
(function (UrlRegExDetection) {
    UrlRegExDetection["Protocol"] = "(http(s)?:\\/\\/)?(www\\.)";
    UrlRegExDetection["Content"] = "[-a-zA-Z0-9@:%._\\+~#=]{2,256}";
    UrlRegExDetection["Domain"] = "[a-z]{2,6}";
    UrlRegExDetection["PathsOrQueryParams"] = "[-a-zA-Z0-9@:%_\\+\\.~#?&\\/\\/=]*";
})(UrlRegExDetection || (UrlRegExDetection = {}));
const URL_DETECTION_REGEX = new RegExp(`${UrlRegExDetection.Protocol}?${UrlRegExDetection.Content}\\.${UrlRegExDetection.Domain}${UrlRegExDetection.PathsOrQueryParams}`, 'g');
const SUBMIT_BUTTON_COMMENT_TEXT = 'Post Comment';
const SUBMIT_BUTTON_QUESTION_TEXT = 'Post Question';
/**
 * Determines if a string is a question by checking if it contains '?'
 * Does not count URLs
 *
 * @param {string} value String to test
 * @returns
 */
const isQuestion = (value) => {
    if (value.includes('?')) {
        const words = value.split(' ');
        return words.every(word => {
            const isUrl = word.match(URL_DETECTION_REGEX);
            return isUrl === null;
        });
    }
    return false;
};
let CommentInlineReply = class CommentInlineReply extends BlueprintComponent {
    constructor(options) {
        super(name, options);
        this.options = options;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.init.call(this);
            this.element = yield BlueprintComponent.loadElement(name, this.options);
            // Initialize the state
            const initState = {
                isRedirectVisible: false,
            };
            // Initialize the module's state
            this.initState(initState);
            this.textArea = this.element.querySelector(`.${TextAreaClassNames.JavaScript}`);
            this.textArea.addEventListener('keyup', this.detectQuestion.bind(this));
            this.redirect = this.element.querySelector(`.${ClassNames.Redirect}`);
            this.submitButton = this.element.querySelector(`.${InlineFormClassNames.SubmitButton}`);
        });
    }
    /**
     * Detects if a question is being asked within the textArea
     */
    detectQuestion() {
        const textContent = this.textArea.value.trim();
        if (!isQuestion(textContent) && this.getState().isRedirectVisible) {
            this.hideRedirect();
        }
        else if (isQuestion(textContent) && !(this.getState().isRedirectVisible)) {
            this.showRedirect();
        }
        // Toggle visibility state of redirect based upon state value
        this.redirect.classList.toggle(ClassNames.RedirectVisible, this.getState().isRedirectVisible);
    }
    /**
     * Sets the isRedirectVisible state to true
     *
     * Initializes the redirect logic if it hasn't been initialized before
     */
    showRedirect() {
        if (!this.redirectInitialized) {
            this.initRedirect();
        }
        this.setState({
            isRedirectVisible: true,
        });
        this.checkboxElement.checked = true;
        this.submitButton.textContent = SUBMIT_BUTTON_QUESTION_TEXT;
        this.setFormValidationRule(this.options.questionValidationRules);
    }
    /**
     * Sets the isRedirectVisible state to false
     *
     * Resets checkbox value, submit button text, and sets the comment validation rules
     */
    hideRedirect() {
        this.setState({
            isRedirectVisible: false,
        });
        this.checkboxElement.checked = false;
        this.submitButton.textContent = SUBMIT_BUTTON_COMMENT_TEXT;
        this.setFormValidationRule(this.options.commentValidationRules);
    }
    /**
     * Initializes redirect logic for visibilityToggle and checkbox change
     *
     * Not automatically instantiated since the redirection logic is conditional, based on user input
     */
    initRedirect() {
        // Sets the form instance to be used in later logic
        const formElement = this.element.querySelector(`.${FormClassNames.JavaScript}`);
        this.formInstance = ComponentRegistry.get(formElement, FormName);
        this.initCheckbox();
        // Flag used to ensure that initialization only happens once
        this.redirectInitialized = true;
    }
    initCheckbox() {
        this.checkboxElement = this.element.querySelector(`.${CheckboxClassNames.JavaScript}`);
        this.checkboxElement.addEventListener('change', this.handleCheckboxChange.bind(this));
    }
    handleCheckboxChange(event) {
        if (event.target.checked) {
            // Change submit button text to Post Question
            this.submitButton.textContent = SUBMIT_BUTTON_QUESTION_TEXT;
            // Change validation rules to be questionValidationRules
            this.setFormValidationRule(this.options.questionValidationRules);
            return;
        }
        this.submitButton.textContent = SUBMIT_BUTTON_COMMENT_TEXT;
        // Once checkbox is unchecked, change validation rules back to commentValidationRules
        this.setFormValidationRule(this.options.commentValidationRules);
    }
    /**
     * Sets validation rules on the form instance (this.formInstance)
     *
     * @param {AdaptorValidationRule[]} validationRules Validation rules to set
     */
    setFormValidationRule(validationRules) {
        this.formInstance.setValidationRules([
            {
                id: this.textArea.id,
                rules: validationRules,
            },
        ]);
    }
};
CommentInlineReply = __decorate([
    stateable(name),
    injectable(name)
], CommentInlineReply);
export default CommentInlineReply;
BlueprintComponent.instantiate(name);
